import Footer from "../../components/VibrantSolComponents/Footer";
import Header from "../../components/VibrantSolComponents/Header";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { MapPin, Phone, Clock } from "lucide-react";
import { Textarea } from "../../components/ui/textarea";
import { Button } from "../../components/ui/button";
function ContactUs() {
  return (
    <>
      <div className="min-h-screen">
        <Header />
        <nav className="flex justify-center py-4 bg-gray-50">
          <ol className="flex items-center space-x-2">
            <li>
              <span className="text-gray-400 font-medium">Home</span>
            </li>
            <li>
              {/* Separator */}
              <span className="text-gray-300 font-medium">——</span>
            </li>
            <li>
              <span className="text-gray-700 font-medium">Contact Us</span>
            </li>
          </ol>
        </nav>

        <section class="pt-12">
          <div class="max-w-7xl mx-auto px-4">
            <div class="flex flex-col items-center text-center">
              <h1 className="text-3xl md:text-4xl text-center mb-6 secdory-font">
                Keep In Touch with Us
              </h1>
              <p className="text-lg text-slate-600 max-w-2xl mx-auto">
                We’re talking about clean beauty gift sets, of course – and
                we’ve got a bouquet of beauties for yourself or someone you
                love.
              </p>
            </div>
            <div className="flex flex-col md:flex-row justify-between mt-10">
              {/* Address */}
              <div className="flex-1 flex items-start flex-col mb-8 md:mb-0">
                <div className="flex items-center mb-3">
                  <MapPin className="text-gray-600 mr-3" size={32} />
                  <span className="text-xl font-semibold">Address</span>
                </div>
                <div className="text-gray-600 space-y-2 ml-11">
                  <div>
                    3245 Abbot Kinney BLVD –<br />
                    PH Venice, CA 124
                  </div>
                  <div>
                    76 East Houston Street
                    <br />
                    PH Venice, CA 124
                  </div>
                </div>
              </div>

              {/* Contact */}
              <div className="flex-1 flex items-start flex-col mb-8 md:mb-0">
                <div className="flex items-center mb-3">
                  <Phone className="text-gray-600 mr-3" size={32} />
                  <span className="text-xl font-semibold">Contact</span>
                </div>
                <div className="ml-11 space-y-2">
                  <div>
                    <span className="text-gray-400">Mobile:&nbsp;&nbsp;</span>
                    <span className="font-medium">068 26589 996</span>
                  </div>
                  <div>
                    <span className="text-gray-400">Hotline:&nbsp;&nbsp;</span>
                    <span className="font-medium">1900 26886</span>
                  </div>
                  <div>
                    <span className="text-gray-400">E-mail:&nbsp;&nbsp;</span>
                    <span className="font-medium">hello@domain.com</span>
                  </div>
                </div>
              </div>

              {/* Hour of Operation */}
              <div className="flex-1 flex items-start flex-col">
                <div className="flex items-center mb-3">
                  <Clock className="text-gray-600 mr-3" size={32} />
                  <span className="text-xl font-semibold">
                    Hour of operation
                  </span>
                </div>
                <div className="ml-11 space-y-2">
                  <div className="flex justify-between w-48">
                    <span>Mon – Fri:</span>
                    <span className="text-gray-400">08:30 – 20:00</span>
                  </div>
                  <div className="flex justify-between w-48">
                    <span>Sat & Sun:</span>
                    <span className="text-gray-400">09:30 – 21:30</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="pt-16">
          <div class="max-w-7xl mx-auto px-4">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52891323.64355656!2d-161.7572472789203!3d35.990241455780485!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54eab584e432360b%3A0x1c3bb99243deb742!2sUnited%20States!5e0!3m2!1sen!2sin!4v1755170708764!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </section>
        <section class="py-16">
          <div class="max-w-7xl mx-auto px-4">
            <div class="flex flex-col items-center text-center">
              <h1 className="text-3xl md:text-4xl text-center mb-6 secdory-font">
                Sent A Message
              </h1>
            </div>
            <div class="max-w-4xl mx-auto px-4">
              <form>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <Input
                      placeholder="Full name"
                      className="w-full mt-2 px-4 py-6 border border-gray-200 rounded-md focus:outline-none"
                    />
                  </div>
                  <div>
                    <Input
                      placeholder="Phone number"
                      className="w-full mt-2 px-4 py-6 border border-gray-200 rounded-md focus:outline-none"
                    />
                  </div>
                  <div className="md:col-span-2">
                    <Input
                      placeholder="Email Id"
                      className="w-full mt-2 px-4 py-6 border border-gray-200 rounded-md focus:outline-none"
                    />
                  </div>
                  <div className="md:col-span-2">
                    <Textarea
                      rows={3}
                      placeholder="Message"
                      className="mt-2 text-sm"
                    />
                  </div>
                  <div className="md:col-span-2 flex justify-center">
                    <Button
                      type="submit"
                      className="bg-primary text-white py-6 px-10 rounded-md font-semibold hover:bg-gray-800 transition"
                    >
                      Submit
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
}
export default ContactUs;
